import { EditedRowView } from 'core/views/editedRow.view.js';

export var SuvietatEditedRowView = EditedRowView.extend({

  canEdit: function() {
    return false;
  }
});